import React from "react";
import './index.less'

type Props = {
  name: string;
  rowKey: string;
  handleCheck?: (station: string) => void;
  checked: boolean;
};

const AnalysisItem = ({
  name,
  handleCheck,
  checked,
  rowKey,
}: Props) => {

  return (
    <div className="analysisItem" onClick={() => {
      handleCheck && handleCheck(rowKey);
    }}>
      <div
        className="item-details"
      >
        <div className="item-details-first-row">
          <div className="item-title">{name}</div>
        </div>
      </div>
      <input
        type="radio"
        checked={checked}
        style={{ width: "15%" }}
      />
    </div>
  );
};

export default AnalysisItem;
